import React from "react";
import { Search } from "react-feather";
import "./interviewLogsCardView.scss";

interface InterviewLogsHistorySearchProps {
  value: string;
  onChange: (value: string) => void;
}

const InterviewLogsHistorySearch: React.FC<InterviewLogsHistorySearchProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className="ilcv-search">
      <Search className="ilcv-search__icon" size={18} />
      <input
        type="search"
        className="ilcv-search__input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search interviews..."
        aria-label="Search interviews"
      />
    </div>
  );
};

export default InterviewLogsHistorySearch;
